import React, { HTMLProps } from 'react';
import classnames from 'classnames';

type SearchPopoverItemProps = HTMLProps<HTMLDivElement> & {
  className?: string;
};

const SearchPopoverItem: React.FC<SearchPopoverItemProps>  = ({
  className,
  ...props
}) => {
  const itemStyle = classnames(
    "flex items-center justify-between px-3 py-2 text-sm font-medium hover:bg-light-0 bg-white w-full", className
  );

  return (
    <div
      className={itemStyle}
      role="button"
      {...props}
    />
  )
}

export default SearchPopoverItem;
